import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/creators/{creatorId}/workflow-roles']['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const bulkUpdateCreatorWorkflowRoles = async ({ creatorId, ...body }: Input): Promise<Output> => {
  const data = await noodleApiClient.put(`/creators/${creatorId}/workflow-roles`, body);
  return data.data;
};

export default bulkUpdateCreatorWorkflowRoles;
